module.exports = __webpack_public_path__ + "/images/pattern-south-america.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/pattern-south-america.png
// module id = 124
// module chunks = 0